import { Component, OnInit, computed } from '@angular/core';

import { CookieService, DynamicHtmlDirective } from '@frontend/vanilla/core';

import { OffersConstants } from '../common-constants/offers-constants';
import { OfferContentConfiguration } from '../offer-content.client-config';
import { LoadOffersApiService } from '../offers-service/load-offers.service';

@Component({
    selector: 'promo-signposting',
    imports: [DynamicHtmlDirective],
    templateUrl: './promo-signposting.component.html',
})
export class PromoSignpostingComponent implements OnInit {
    showBanner: boolean = true;
    promoSignPostingContent = computed(() => this.loadOffersApiService.promoSignPostingContent$());

    constructor(
        private loadOffersApiService: LoadOffersApiService,
        private cookie: CookieService,
        private offerContentConfig: OfferContentConfiguration,
    ) {}

    ngOnInit() {
        const value = this.cookie.get(OffersConstants.PromoSignPostingBannerClosed);
        if (value == 'true') this.showBanner = false;
    }

    onCloseBanner() {
        this.showBanner = false;
        const expireDate = new Date();
        expireDate.setDate(expireDate.getDate() + this.offerContentConfig.cookieExpiryDuration);
        this.cookie.put(OffersConstants.PromoSignPostingBannerClosed, 'true', { expires: expireDate });
    }
}
